/******/ (function() { // webpackBootstrap
var __webpack_exports__ = {};
class QuantityInput extends HTMLElement {
  constructor() {
    super();
    this.isSyncing = false;
    this.init();
  }
  init() {
    this.input = this.querySelector('input');
    if (!this.input) return;
    this.changeEvent = new Event('change', {
      bubbles: true
    });
    this.onInputChange = this.onInputChange.bind(this);
    this.onButtonClick = this.onButtonClick.bind(this);
    this.input.addEventListener('change', this.onInputChange);
    this.querySelectorAll('button').forEach(button => {
      button.addEventListener('click', this.onButtonClick);
    });
  }
  quantityUpdateUnsubscriber = undefined;
  connectedCallback() {
    this.validateQtyRules();
    this.quantityUpdateUnsubscriber = subscribe(PUB_SUB_EVENTS.quantityUpdate, this.validateQtyRules.bind(this));
  }
  disconnectedCallback() {
    if (this.quantityUpdateUnsubscriber) this.quantityUpdateUnsubscriber();
    this.input?.removeEventListener('change', this.onInputChange);
    this.querySelectorAll('button').forEach(button => {
      button.removeEventListener('click', this.onButtonClick);
    });
  }
  onInputChange() {
    this.validateQtyRules();
    this.syncQuantityToSiblings();
  }
  onButtonClick(event) {
    event.preventDefault();
    const btn = event.target.closest('button');
    if (!btn) return;
    const previousValue = this.input.value;
    if (btn.name === 'plus') {
      if (parseInt(this.input.dataset.min) > parseInt(this.input.step) && this.input.value == 0) {
        this.input.value = this.input.dataset.min;
      } else {
        this.input.stepUp();
      }
    } else if (btn.name === 'minus') {
      this.input.stepDown();
    }
    if (previousValue !== this.input.value) {
      this.input.dispatchEvent(this.changeEvent);
    }
    if (this.input.dataset.min === previousValue && btn.name === 'minus') {
      this.input.value = parseInt(this.input.min);
    }
  }
  syncQuantityToSiblings() {
    if (this.isSyncing) return;
    const root = this.closest('product-info');
    if (!root) return;
    const value = this.input.value;
    const otherInputs = root.querySelectorAll('quantity-input input[name="quantity"]');
    this.isSyncing = true;
    otherInputs.forEach(inp => {
      if (inp === this.input) return;
      if (inp.value === value) return;
      inp.value = value;
      inp.dispatchEvent(new Event('change', {
        bubbles: true
      }));
    });
    this.isSyncing = false;
  }
  validateQtyRules() {
    const value = parseInt(this.input.value);
    if (this.input.min) {
      const buttonMinus = this.querySelector(".quantity__button[name='minus']");
      buttonMinus?.classList.toggle('disabled', value <= parseInt(this.input.min));
    }
    if (this.input.max) {
      const max = parseInt(this.input.max);
      const buttonPlus = this.querySelector(".quantity__button[name='plus']");
      buttonPlus?.classList.toggle('disabled', value >= max);
    }
  }
}
if (!customElements.get('quantity-input')) {
  customElements.define('quantity-input', QuantityInput);
}
/******/ })()
;